import { useT } from "@/i18n/LanguageContext";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const ASSETS = `${BACKEND_URL}/api/assets`;

const SERVICE_META = [
  { key: "mobil", num: "01", image: `${ASSETS}/service_mobile.png`, span: "md:col-span-7 md:row-span-2", ratio: "md:aspect-auto aspect-[5/4]", tags: ["React Native", "Swift", "Kotlin", "Flutter"] },
  { key: "program", num: "02", image: `${ASSETS}/service_software.png`, span: "md:col-span-5", ratio: "aspect-[5/4]", tags: ["ERP", "CRM", "License", "Automation"] },
  { key: "web", num: "03", image: `${ASSETS}/service_webdesign.png`, span: "md:col-span-5", ratio: "aspect-[5/4]", tags: ["React", "Next.js", "Tailwind", "Headless CMS"] },
  { key: "ai", num: "04", image: `${ASSETS}/service_ai.png`, span: "md:col-span-4", ratio: "aspect-[4/5]", tags: ["GPT-5", "Claude", "LangChain", "Vector DB"] },
  { key: "danismanlik", num: "05", image: `${ASSETS}/service_consulting.png`, span: "md:col-span-8", ratio: "md:aspect-[16/9] aspect-[5/4]", tags: ["Architecture", "DevOps", "Security", "Training"] },
];

export default function Services() {
  const { t } = useT();

  return (
    <section id="services" data-testid="services-section" className="relative py-28 md:py-40 overflow-hidden">
      <div className="blob blob-4" style={{ width: 500, height: 500, top: "10%", right: "-200px", opacity: 0.25 }} data-parallax="0.08" />
      <div className="blob blob-3" style={{ width: 400, height: 400, bottom: "5%", left: "-150px", opacity: 0.3 }} data-parallax="-0.05" />

      <div className="container mx-auto px-6 md:px-12 max-w-7xl relative">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-16">
          <div className="reveal">
            <div className="flex items-center gap-3 mb-5">
              <span className="h-[1px] w-10 bg-[#0F0524]/40" />
              <span className="text-[11px] uppercase tracking-[0.3em] text-[#5C527A] font-semibold">
                {t("services.eyebrow")}
              </span>
            </div>
            <h2 className="font-display text-5xl md:text-7xl font-extralight leading-[0.95] tracking-[-0.04em] text-[#0F0524]">
              {t("services.titleA")} <span className="italic grad-text">{t("services.titleB")}</span>
              <br />
              {t("services.titleC")}
            </h2>
          </div>
          <p className="reveal max-w-md text-[15px] text-[#5C527A] leading-relaxed">
            {t("services.desc")}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-5 md:gap-6">
          {SERVICE_META.map((s, i) => {
            const item = t(`services.items.${s.key}`);
            return (
              <article
                key={s.key}
                data-testid={`service-card-${s.key}`}
                className={`svc-card reveal relative group rounded-3xl overflow-hidden ${s.span} ${s.ratio}`}
                style={{ transitionDelay: `${i * 90}ms` }}
              >
                <img src={s.image} alt={item.title} className="absolute inset-0 h-full w-full object-cover" loading="lazy" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0F0524]/85 via-[#0F0524]/30 to-transparent" />
                <div className="absolute top-5 left-5 right-5 flex items-center justify-between text-white/90">
                  <span className="font-display font-light text-sm tracking-widest">/{s.num}</span>
                  <span className="text-[10px] uppercase tracking-[0.25em] opacity-80">{item.subtitle}</span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8 text-white">
                  <h3 className="font-display text-2xl md:text-3xl font-light leading-tight tracking-tight">
                    {item.title}
                  </h3>
                  <p className="mt-3 text-[13px] md:text-[14px] leading-relaxed text-white/75 max-w-md">
                    {item.desc}
                  </p>
                  <div className="mt-5 flex flex-wrap gap-2">
                    {s.tags.map((tg) => (
                      <span key={tg} className="inline-flex items-center rounded-full border border-white/25 bg-white/10 backdrop-blur-sm px-3 py-1 text-[11px] font-medium text-white/90">
                        {tg}
                      </span>
                    ))}
                  </div>
                </div>
                <div className="pointer-events-none absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                  <div className="absolute -inset-1 iridescent opacity-20" />
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
